module.exports = {
  API_URL: "https://api.tuhinwin.workers.dev", // without '/'
  RECAPTCHA_API_TOKEN: "6LevLmMaAAAAAL6LKLQOT1xiCEcCoPBQPUTP3_-R", // Client Side
};
